<template>
	<div class="modal" id="new-modal" tabindex="-1" role="dialog" aria-labelledby="new-modal" aria-hidden="true">
		<div class="modal-dialog" role="document" >
			<div class="modal-content">
				<div class="block block-themed block-transparent mb-0" id="new-modal-content">
					<div class="block-header bg-primary-dark">
						<h3 class="block-title">New {{ Bandwango.ucwords(modalData.assignment) }}</h3>
						<div class="block-options">
							<button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
								<i class="fa fa-fw fa-times"></i>
							</button>
						</div>
					</div>
					<div class="block-content" >
						<div class="form-group" v-if="!modalData.forcedCreateFrom">
							<label>Create a {{modalData.assignment}} from</label>
							<select class="form-control" v-model="createFrom">
								<option :value="null">- Select One -</option>
								<option value="template">Template</option>
	<!--							<option value="product">Existing Product</option>-->
								<option value="blank">Blank {{ Bandwango.ucwords(modalData.assignment) }}</option>
							</select>
						</div>
						<div class="form-group" v-if="createFrom == 'template'">
							<label>Template</label>
							<select class="form-control" v-model="createFromId">
								<option :value="null">- Select One -</option>
								<option :value="template.id" v-for="template in modalData.templates">{{ template.name }}</option>
							</select>
						</div>
					</div>
					<div class="block-content block-content-full text-right border-top">
						<button type="button" class="btn btn-sm btn-light" data-dismiss="modal">Cancel</button>
						<button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" @click="create()" :disabled="!canCreate()">Create</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
	<script>

		export default {
			props: {
				modalData: {
					type: Object,
					required: true,
				},
			},
			data: () => {
				return {
					success_msg: '',
					error_msg: '',
					createFrom:null,
					createFromId:null,
				}
			},
			methods: {
				create() {
					let url = this.modalData.newLink;

					if( this.createFrom != 'blank' ) {

						if( !this.createFromId ) {
							this.error_msg = 'Please select a '+this.createFrom+' to create from.';
							return;
						}

						if( url.indexOf('?') == -1 )
							url += '?';
						else
							url += '&';

						url += 'createFrom='+this.createFrom+'&createFromId='+this.createFromId;
					}

					window.location = url;
				},
				canCreate() {
					if( this.createFrom == 'blank' ) return true;
					if( this.createFrom && this.createFromId ) return true;
					return false;
				}
			},
			mounted() {
				const vm = this;
                if( this.modalData.forcedCreateFrom ) {
                    this.createFrom = this.modalData.forcedCreateFrom;
                }
				$(() =>{
					$('#new-modal').on('hidden.bs.modal', function (e) {
						vm.createFrom = null;
						vm.createFromId = null;
					});
				});
			},
			watch: {
				success_msg: function(msg) {
					if( msg ) {
						One.helpers('notify', {align: 'center', type: 'success', icon: 'fa fa-check mr-1', message: msg});
						this.success_msg = '';
					}
				},
				error_msg: function(msg) {
					if( msg ) {
						One.helpers('notify', {align: 'center', type: 'danger', icon: 'fa fa-exclamation mr-1', message: msg});
						this.error_msg = '';
					}
				},
			},
		};

	</script>

	<style>

	</style>
